// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Image.module.css */

/* Stil za pojedinačnu sliku */
.Image_image__rbUYc {
  display: block;
  max-width: 100%;
  height: auto;
  border-radius: 5px;
}

/* Centrirana slika */
.Image_centered__IInPl {
  display: block;
  margin: 0 auto;
}

/* Zaobljena slika */
.Image_circular__hOavq {
  border-radius: 50%;
}

/* Grupa slika */
.Image_image-group__HjfUv {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/common/components/Image/Image.module.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB,8BAA8B;AAC9B;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB","sourcesContent":["/* Image.module.css */\n\n/* Stil za pojedinačnu sliku */\n.image {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  border-radius: 5px;\n}\n\n/* Centrirana slika */\n.centered {\n  display: block;\n  margin: 0 auto;\n}\n\n/* Zaobljena slika */\n.circular {\n  border-radius: 50%;\n}\n\n/* Grupa slika */\n.image-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `Image_image__rbUYc`,
	"centered": `Image_centered__IInPl`,
	"circular": `Image_circular__hOavq`,
	"image-group": `Image_image-group__HjfUv`
};
export default ___CSS_LOADER_EXPORT___;
